import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AuthorizationService } from 'src/app/core/services/authorization/authorization.service';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { Router } from '@angular/router';
import { ExternalCrewLoginData } from 'src/app/models/ExternalCrewLoginData';
import { ExternalTripAccessDataResponse } from 'src/app/models/ExternalTripAccessDataResponse';
import { CrewInfoStore } from 'src/app/core/services/crew-info/crew-info.store';
import { assign } from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { ExternalCrewInfo } from 'src/app/models/ExternalCrewInfo';
import { ConfigService } from 'src/app/core/services/config/config.service';
import { GoogleAuthenticationService } from 'src/app/core/services/login/google-authentication.service';
import { AccessRestrictionDialogService } from 'src/app/shared/services/access-restriction-dialog.service';

declare var grecaptcha: any;
@Component({
  selector: 'app-external-login',
  templateUrl: './external-login.component.html',
  styleUrls: ['./external-login.component.scss'],
  standalone: false
})
export class ExternalLoginComponent {

  submited: boolean;
  viewPassword: boolean;

  loginForm: FormGroup = new FormGroup({
    user: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  @ViewChild('inputPassword') inputPassword: ElementRef;
  @ViewChild('iconPassword') iconPassword: ElementRef;

  constructor(
    private authorizationService: AuthorizationService,
    private notificationService: NotificationService,
    private dialog: MatDialog,
    private router: Router,
    private configService: ConfigService,
    private googleAuthenticationService: GoogleAuthenticationService,
    private crewInfoStore: CrewInfoStore,
    private accessRestrictionDialogService: AccessRestrictionDialogService,
  ) { }

  async login() {
    this.submited = true;

    if (this.loginForm.valid) {
      sessionStorage.clear(); // Clear any stale sessions/tokens
      this.crewInfoStore.clear();

      const tokenReCaptcha = await this.genereteReCaptchaToken();

      const loginData: ExternalCrewLoginData = this.loginForm.getRawValue();

      this.authorizationService.externalCrewValidate(loginData, tokenReCaptcha).subscribe({
        next: (loginRespose: ExternalTripAccessDataResponse) => {

          loginRespose = assign(new ExternalTripAccessDataResponse(), loginRespose);
          const crewInfo: ExternalCrewInfo = loginRespose.toCrewInfo();

          if (crewInfo.blocked || !crewInfo.hasAccess) {
            this.accessRestrictionDialogService.open({
              blocked: crewInfo.blocked,
              active: !crewInfo.blocked && crewInfo.hasAccess,
              accessDeniedMessage: crewInfo.accessDeniedMessage,
            });
            return;
          }

          this.crewInfoStore.setCrewInfo(crewInfo);
          if (loginRespose.token) {
            this.googleAuthenticationService.setAccessToken(loginRespose.token);
          }

          // Security: Redirect to validation page if MFA or first access is required
          if (crewInfo.requiresMfa || crewInfo.firstAccess) {
            this.router.navigate(['/external-validation']);
          } else {
            this.router.navigate(['/external-home']);
          }
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.notificationService.error('Código ANAC e/ou senha incorreta!');
          } else if (error.status === 403) {
            this.notificationService.error('detecção reCaptcha inválido!');
          } else {
            this.notificationService.error('Ocorreu um erro inesperado!');
          }
        }
      });
    }
  }

  private async genereteReCaptchaToken(): Promise<string> {
    const token = await grecaptcha.enterprise.execute(this.configService.settings.recaptcha_key, { action: 'externalLogin' });
    return token;
  }

  toogleIconPassword(): void {
    this.viewPassword = !this.viewPassword;

    if (this.viewPassword) {
      this.inputPassword.nativeElement.setAttribute('type', 'text');
      this.iconPassword.nativeElement.setAttribute('src', 'assets/images/eye-hide.png');
    } else {
      this.inputPassword.nativeElement.setAttribute('type', 'password');
      this.iconPassword.nativeElement.setAttribute('src', 'assets/images/eye-view.png');
    }
  }

  openResetPasswordDialog(): void {
    this.dialog.open(ResetPasswordComponent, { width: '600px' });
  }

  back() {
    this.router.navigate(['/']);
  }
}